var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-sold"},[_c('i',{staticClass:"las la-cart-arrow-down",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.sold)}})])}
var staticRenderFns = []

export { render, staticRenderFns }